import * as Roles from '@/store/roles';

export const projectActionsPermissions = {
  addProjectUserItem: [Roles.Admin, Roles.ProjectLeader, Roles.Trial],
  addSyncedProject: [Roles.Any],
  copyChildren: [Roles.Admin, Roles.ProjectLeader, Roles.Trial],
  copyChildNode: [Roles.Any],
  createProject: [Roles.Admin, Roles.ProjectLeader, Roles.Trial],
  duplicateProject: [Roles.Admin], // Roles.ProjectLeader and Roles.Trial were excluded by customer's request
  getDefaultProject: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  getProjectJson: [Roles.Admin], // Roles.ProjectLeader and Roles.Trial were excluded by customer's request
  getProjectLog: [Roles.Admin],
  getStandardProject: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  importProject: [Roles.Admin, Roles.ProjectLeader, Roles.Trial],
  loadProject: [Roles.Any],
  lockProject: [Roles.Admin],
  viewProjectOverview: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  projectChildMoved: [Roles.Admin, Roles.ProjectLeader, Roles.Trial],
  pasteChildNode: [Roles.Admin, Roles.ProjectLeader, Roles.Trial],
  saveProjectProperties: [Roles.Admin, Roles.ProjectLeader, Roles.Trial],
  setProjectProperties: [Roles.Admin, Roles.ProjectLeader, Roles.Trial],
  syncProjectProperties: [Roles.Any],
  updateProjectList: [Roles.Any],
  updateProjectUserItem: [Roles.Admin, Roles.ProjectLeader, Roles.Trial],
  addProjectUserItemByIndex: [Roles.Admin, Roles.ProjectLeader, Roles.SiteManager, Roles.SiteAssistant],
  updateProjectUserItemOccupation: [Roles.Admin, Roles.ProjectLeader, Roles.SiteManager, Roles.SiteAssistant],
  deleteProjectUserItem: [Roles.Admin, Roles.ProjectLeader, Roles.SiteManager, Roles.SiteAssistant],
};



// WEBPACK FOOTER //
// ./src/store/project/projectActionsPermissions.js